'use client'

import { FC, RefObject, useEffect, useRef } from 'react'
import cx from 'classnames'
import { Panel } from '../../Panel/Panel'
import { PanelItem } from '../../Panel/PanelItem'
import { useScrolledIntoViewEvent } from '@/hooks/useAnalytics'
import { useLocationPage } from '@/hooks/useLocationPage'
import { Colour } from '../../constants/colours'
import { useScrolledIntoView } from '@/hooks/useScrolledIntoView'
import { Templates, TrustBox } from './TrustBox'
import styles from './styles.module.scss'
import { CmsPageSectionBase } from '@/components/ComposedPage'
import { SectionPaddingDefault } from '@/components/constants'

export enum WidgetType {
  Slider = 'Slider',
  MicroCombo = 'MicroCombo',
  Horizontal = 'Horizontal',
}

export interface CmsTrustPilotSection extends CmsPageSectionBase {
  fields: CmsPageSectionBase['fields'] & {
    title?: string
    widgetType?: WidgetType
  }
}

export const TrustPilotSection: FC<CmsTrustPilotSection> = ({ fields }) => {
  const panelRef = useRef<HTMLElement>(null) as RefObject<HTMLElement>
  const page = useLocationPage()
  const pushScrolledIntoView = useScrolledIntoViewEvent('Trustpilot', page)
  const { displayed } = useScrolledIntoView(panelRef.current)

  useEffect(() => {
    if (displayed) {
      pushScrolledIntoView()
    }
  }, [displayed, pushScrolledIntoView])

  return (
    <Panel
      id="trustBoxSection"
      className={cx(
        styles.container,
        styles[fields.sectionPaddingTop || SectionPaddingDefault.TOP],
        styles[fields.sectionPaddingBottom || SectionPaddingDefault.BOTTOM],
      )}
      colour={Colour.warmStone}
      forwardRef={panelRef}
      short
    >
      <PanelItem>
        {(!fields.widgetType || fields.widgetType === WidgetType.Slider) && (
          <>
            <div className={styles.titleContainer}>
              {fields.title && <p className={styles.title}>{fields.title}</p>}
              <span className={styles.microStar}>
                <TrustBox template={Templates.MicroStar} />
              </span>
            </div>
            <div className={styles.item}>
              <TrustBox template={Templates.Slider} />
            </div>
          </>
        )}

        {fields.widgetType === WidgetType.MicroCombo && (
          <div className={styles.item}>
            <TrustBox template={Templates.MicroCombo} />
          </div>
        )}

        {fields.widgetType === WidgetType.Horizontal && (
          <div className={styles.item}>
            <TrustBox template={Templates.Horizontal} />
          </div>
        )}
      </PanelItem>
    </Panel>
  )
}
